import { GhostBlock } from "@faire/deprecated-retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";

export const GhostText: React.FC = () => (
  <GhostBlock $width={getSpacing(120)} $height={getSpacing(20)} />
);

export const GhostHeader: React.FC = () => (
  <GhostBlock $width={getSpacing(120)} $height={getSpacing("4x")} />
);
